import { Directive, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Directive({
  selector: '[appDebounce]',
})
export class DebounceDirective implements OnInit, OnDestroy, OnChanges {
  @Input()
  debounceTime = 1000;

  @Input()
  inputVal: any;

  @Output()
  emitter: EventEmitter<string> = new EventEmitter<string>();

  private eventSubject = new Subject<string>();

  constructor() {}

  ngOnInit(): void {
    this.eventSubject
      .pipe(
        debounceTime(this.debounceTime),
        distinctUntilChanged(),
        tap((value) => this.emitter.emit(value)),
      )
      .subscribe();
  }

  ngOnChanges(): void {
    this.eventSubject.next(this.inputVal);
  }

  ngOnDestroy() {
    this.eventSubject.complete();
  }
}
